export class SurchargeModel {
    sale_amount: number;
    surcharge_prohibited: boolean;
    surcharge_rate: number;
    surcharge_amount: number;
    surcharge_description: string;
    transaction_total: number;
}
